import CommonSummary from 'cart/Summary';
import { useLocalization } from 'redux/localization/utils/hooks';

import Proceed from './summary/Proceed';

const Summary = () => {
  const { t } = useLocalization();
  return (
    <>
      <div className="c7-side-cart__summary-container">
        <div className="c7-order-summary">
          <h2 className="c7-sr-only c7-h2">
            {t('checkout.general.orderSummary')}
          </h2>
          <CommonSummary showTotalRemaining={false} />
          <Proceed />
        </div>
      </div>
    </>
  );
};

export default Summary;
